import { render, staticRenderFns } from "./feadback.vue?vue&type=template&id=144270be&"
import script from "./feadback.vue?vue&type=script&lang=js&"
export * from "./feadback.vue?vue&type=script&lang=js&"
import style0 from "./feadback.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports